import { createAsyncThunk, Draft, PayloadAction } from "@reduxjs/toolkit";
import { createRestSlice, ItemState } from "./restSlice";
import { makeRequest } from "../../utils/request";

export type OrganizationCustomVoice = {
  id: string;
  organizationId: string;
  name: string;
  description: string;
  language: string;
  createdAt: Date;
  updatedAt: Date;
  deletedAt: Date | null;
  previewAudioUrl?: string;
  originalAudioSampleUrl?: string;
};

// Custom async thunk for voice cloning
export const createVoiceClone = createAsyncThunk(
  "organizationCustomVoices/createVoiceClone",
  async (params: { name: string; description: string; language: string; file: File }) => {
    const { data } = await makeRequest<{ data: OrganizationCustomVoice }>(`/v1/organization-voices/clone`, {
      method: "POST",
      file: params.file,
      body: {
        name: params.name,
        description: params.description,
        language: params.language,
      },
    });
    return data;
  },
);

// Create the base REST slice with custom extraReducers
const organizationCustomVoicesSlice = createRestSlice<OrganizationCustomVoice>("organizationCustomVoices", "/v1/organization-voices", {
  extraReducers: (builder) => {
    builder.addCase(createVoiceClone.pending, (state: Draft<ItemState<OrganizationCustomVoice>>) => {
      state.isLoadingCreate = true;
    });
    builder.addCase(createVoiceClone.fulfilled, (state: Draft<ItemState<OrganizationCustomVoice>>, action: PayloadAction<OrganizationCustomVoice>) => {
      state.isLoadingCreate = false;
      const newVoice = action.payload;
      state.entities[newVoice.id] = newVoice as Draft<OrganizationCustomVoice>;
      if (!state.ids.includes(newVoice.id)) {
        state.ids.push(newVoice.id);
      }
    });
    builder.addCase(createVoiceClone.rejected, (state: Draft<ItemState<OrganizationCustomVoice>>) => {
      state.isLoadingCreate = false;
    });
  },
});

export const organizationCustomVoicesReducer = organizationCustomVoicesSlice.reducer;
export const organizationCustomVoicesActions = {
  ...organizationCustomVoicesSlice.actions,
  createVoiceClone,
};
